import { Component, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FeatureSwitchTurnOffItem } from '../../_models/admin/feature-switch.models';

export interface FeatureSwitchBulkOffData {
  /** What was asked for, e.g. "every feature" or "features introduced on or after 27/09/2026". */
  scope: string;
  /** The dry run's list: exactly the features that will go off. */
  switches: FeatureSwitchTurnOffItem[];
}

/**
 * Confirms a bulk turn-off. Lists exactly the features the dry run found, with the count, and closes with
 * true only when the admin confirms. Closing any other way (Cancel, Escape, the backdrop) is a no.
 */
@Component({
  selector: 'feature-switch-bulk-off-dialog',
  standalone: true,
  imports: [DatePipe],
  templateUrl: 'feature-switch-bulk-off-dialog.component.html'
})
export class FeatureSwitchBulkOffDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FeatureSwitchBulkOffData,
    private dialogRef: MatDialogRef<FeatureSwitchBulkOffDialogComponent, boolean>
  ) { }

  /** The features that will go off. */
  public get toTurnOff(): FeatureSwitchTurnOffItem[] {
    return (this.data.switches || []).filter(s => !s.skippedReason);
  }

  /** The ones the dry run left out (an adopted switch, unless "include adopted" was ticked), with why. */
  public get skipped(): FeatureSwitchTurnOffItem[] {
    return (this.data.switches || []).filter(s => !!s.skippedReason);
  }

  public get count(): number {
    return this.toTurnOff.length;
  }

  public confirm(): void {
    this.dialogRef.close(true);
  }

  public cancel(): void {
    this.dialogRef.close(false);
  }
}
